import { getCookie} from '../commons/HelperFunctions';
import { LanderCookie } from '../commons/Constants';
import messages_en_us from "./locales/en-US.json";
//This is a country code to locale map
const localeMap = {
  DEFAULT: 'en',
  US: 'en'
}

const messages = {
  'en': messages_en_us,
};

export function getLocaleFromCookie() {
  const countryCode = getCookie(LanderCookie.COUNTRY)
  if(localeMap[countryCode]){
    return localeMap[countryCode];
  }
  return localeMap.DEFAULT;
}

export function getLocalizedMessages(locale) {
  return messages[locale];
}